// Single source of truth for all UI strings.

export const translations = {
  en: {
    nav: {
      about: 'About',
      beliefs: 'Beliefs',
      leaders: 'Leaders',
      fellowships: 'Fellowships',
      service: 'Service',
      anthology: 'Anthology',
      contact: 'Contact',
    },
    hero: {
      label: 'Welcome to',
      title: 'Brooklyn Community Christian Church',
      subtitle: "A Community of Faith in Brooklyn, celebrating God's love through worship, fellowship, and service.",
      cta: 'Join us for Sunday Service',
    },
    bibleVerse: {
      line1: 'Equipping Godly Men and Godly Women,',
      line2: 'Building Godly Families,',
      line3: 'Raising Godly Children.',
      verse: "We will not hide them from their children, but tell to the coming generation the glorious deeds of the Lord, and his might, and the wonders that he has done.",
      attribution: '— Psalm 78:4',
    },
    anthology: {
      heading: 'Anthology',
      clickCaption: 'Click the book to read!',
      description1: 'The following anthology was created in the summer of 2023 by SBI (Summa Bible Institute) 7.0, a youth ministry team from Brooklyn Community Christian Church. Our goal is to model ourselves after 1 Timothy 4:12:',
      verse: 'Let no one despise you for your youth, but set the believers an example in speech, in conduct, in love, in faith, in purity.',
      description2: "Each SBI member has written their testimony, a story detailing their experiences with God and their acceptance of Jesus Christ as their Lord and Savior. Along with their testimony, we have each submitted creative works which serve as expressions of our faith in Jesus. God has done so much in our lives, and we only wish to share it with the world. We're hoping you will be inspired and moved by these works.",
      directors: 'SBI 7.0 Directors',
      directorsNames: 'Simeon Leung and Cullen Ye',
    },
    services: {
      heading: 'Service Times & Location',
      nextSunday: 'Next Sunday Service',
      combinedNoteIntro: 'Combined service only on Holidays, for',
      combinedNoteHighlight: 'Regular Service',
      combinedNoteSuffix: 'times:',
      combinedSubtext: 'Chinese + English Combined',
      chinese: { name: 'Chinese Service' },
      english: { name: 'English Service' },
      specials: {
        easterSunday: 'Easter Sunday Service',
        mothersDay:   "Mother's Day Service",
        fathersDay:   "Father's Day Service",
      },
      regularNote: "Combined English & Chinese Service: 10:00 AM\u201312:00 PM on select holidays (Easter, Mother's Day, Father's Day, Christmas).",
    },
    zoom: {
      actionText: 'Service is live • Join now',
    },
    fellowships: {
      heading: 'All Our Fellowships',
      weeklyHeading: 'Weekly Gatherings',
      viewAll: 'See All Our Fellowships',
      colFellowship: 'Fellowship',
      colDayTime: 'Day / Time',
      requiresReg: '(requires registration)',
      online: '(Online)',
      entries: {
        mandarinAdultSundaySchool: { name: 'Mandarin Adult Sunday School', time: 'Sundays, 12:00PM - 1:00PM' },
        mensGroup:                  { name: "Men's Group",                  time: 'Sundays, 12:30PM - 2:30PM' },
        sistersTheologyClass:       { name: "Sisters' Theology Class",      time: 'Sundays, 1:30PM - 2:30PM' },
        qaTheologyDiscussion:       { name: 'Q&A: Theology Discussion',     time: 'Sundays, 5:30PM - 6:30PM' },
        eveningSing:                { name: 'Evening Sing',                 time: 'Sundays, 8:00PM - 9:00PM' },
        chineseEveningService:      { name: 'Chinese Evening Service',      time: 'Sundays, 9:30PM - 10:30PM' },
        englishPrayerMeeting:       { name: 'English Prayer Meeting',       time: 'Tuesdays, 7:30PM - 9:30PM' },
        familyFellowship:           { name: 'Family Fellowship',            time: 'Tuesdays, 8:00PM - 9:30PM' },
        wednesdayBibleStudy:        { name: 'Wednesday AM Bible Study & Prayer', time: 'Wednesdays, 9:00AM - 11:30AM' },
        chinesePrayerMeeting:       { name: 'Chinese Prayer Meeting',       time: 'Wednesdays, 8:00PM - 9:30PM' },
        elderlyFellowship:          { name: 'Elderly Fellowship',           time: 'Thursdays, 10:00AM - 12:00PM' },
        godkeyFellowship:           { name: 'Godkey Fellowship',            time: 'Fridays, 7:45PM - 10:00PM' },
        fridayNightFellowship:      { name: 'Friday Night Fellowship',      time: 'Fridays, 7:30PM - 9:30PM' },
        mandarinFellowship:         { name: 'Mandarin Fellowship',          time: 'Fridays, 7:30PM - 9:30PM' },
        cantoneseFellowship:        { name: 'Cantonese Fellowship',         time: '1st, 2nd, 3rd Fridays, 7:00PM - 8:30PM' },
        practicalTheologyClass:     { name: 'Practical Theology Class',     time: 'Saturdays, 9:00AM - 10:30AM' },
      },
    },
    sof: {
      heading: 'Statement Of Faith',
      item1: 'We believe that all Scripture, consisting of 66 books in the Old and New Testament, are the only divinely inspired infallible words of God. Scripture is the supreme authority in all matters of faith and conduct.',
      item2: 'We believe that there is one living and true God, eternally existing as three Persons, the Father, the Son and the Holy Spirit, equal in power and glory; that this triune God created all, upholds all and governs all.',
      item3: 'We believe that Jesus Christ our Lord is the Son of God - both fully God and fully man, the Savior of the world, and that through His life, death and resurrection an atonement was made for sin and redemption was provided for mankind.',
      item4: 'We believe that the repentance of sin and the receiving of Jesus Christ as personal Savior is the one and only way whereby sinful man can inherit eternal life.',
      item5: 'We believe that the Holy Spirit, the Third Person of the blessed Trinity brings people into a saving relation with God, and that He is the Comforter and Guide of all who receive Jesus Christ as personal Savior.',
      item6: 'We believe that man was created in the image of God for the purpose to glorify God. We believe as the result of the fall, sin entered as a universal condition to the human race and that sin condemned the whole human race to death.',
      item7: 'We believe that at the end of the age, the Lord Jesus Christ will descend from Heaven to redeem his people into eternal life, and to judge the wicked into eternal death.',
      item8: 'We believe that the Church is the body of believers united in Christ with Christ as the head. The church invisible and universal is composed of the redeemed of all ages. The local church is the visible manifestation of the invisible church.',
      item9: 'We believe baptism by water is the public confession of Christ as Savior and Lord. It is a symbol of one\'s union by faith with Christ in death, burial and resurrection.',
      item10: "We believe that the Lord's supper should be observed by all. It consists of partaking corporately the bread and wine; symbolizing the death of Christ for the remission of sins, and our continual dependence upon Him for our sustenance.",
      item11: {
        pre: 'Brooklyn Community Christian Church is in voluntary cooperation with the ',
        sbc: 'Southern Baptist Convention',
        mid: '. Our shared beliefs align with the core doctrines found in ',
        bfm: 'The Baptist Faith and Message',
        post: '.',
      },
    },
    team: {
      heading: 'Meet the Team',
      subtitle: 'Shepherding our community with faith, wisdom, and compassion',
      members: {
        andyTso: {
          role: 'Lead Pastor',
          bio: `Pastor Andy grew up a 1st-generation-immigrant-restaurant-kid in NYC. He attended NYC public schools, Catholic HS, graduated from NYU (BA), Gordon Conwell Seminary (MDiv) and retired from law practice as a NYS Attorney. His claim to fame: his father created Orange Beef. He speaks fluent Brooklynese, Mando, Canto, and Fujian-Minnan.

Andy and Hilary have served in pastoral ministry for more than 30 years. They homeschooled their four (now adult and married) children, and have four grandchildren. Their greatest joy is seeing all their children and grandchildren "walking in the truth".`,
        },
        simeonLeung: {
          role: 'Assistant Pastor',
          bio: `Simeon serves as the Assistant Pastor at BCCC, where he primarily ministers to high school students while also supporting a range of church ministries. He stepped into full-time service in 2021, driven by a desire to teach God's Word faithfully and disciple the next generation to follow Christ with joy and fervor. He is currently pursuing seminary training to be further equipped for ministry. Alongside his pastoral responsibilities, Simeon has a deep love for music and often serves by leading worship through playing guitar and piano. In his free time, he enjoys exploring the outdoors, playing volleyball, and having theological conversations in search of biblical truth.`,
        },
        cullenYe: {
          role: 'Pastoral Intern',
          bio: `Cullen serves as the pastoral intern at BCCC, where he oversees the college ministry, leads the summer high school ministry, and regularly preaches and teaches. He graduated from the University of Michigan (Go Blue!) with a degree in computer science but soon felt God's call to full-time ministry. He is currently pursuing his Master of Divinity with a concentration in Apologetics and Philosophy at the Southern Baptist Theological Seminary. Cullen is passionate about helping others think deeply about their faith and hopes to pursue academia in philosophy and theology. Outside of ministry, he enjoys powerlifting, playing table tennis, strumming his guitar, reading, and watching college football.`,
        },
      },
    },
    footer: {
      tagline: 'A Community of Faith in Brooklyn',
      contactHeading: 'Contact Us',
      followHeading: 'Follow Us',
      address1: '2287 East 15th St.',
      address2: 'Brooklyn, NY 11229',
      copyright: 'Brooklyn Community Christian Church. All rights reserved.',
    },
  },
  zh: {
    nav: {
      about: '關於我們',
      beliefs: '我們的信仰',
      leaders: '牧師',
      fellowships: '團契',
      service: '日程安排',
      anthology: '文集',
      contact: '聯絡我們',
    },
    hero: {
      label: '歡迎來到',
      title: '布魯克林社區基督教會',
      subtitle: '布魯克林的信仰群體，藉著敬拜、相交與服事，一同頌揚神的愛。',
      cta: '加入主日崇拜',
    },
    bibleVerse: {
      line1: '裝備敬虔的弟兄和敬虔的姊妹，',
      line2: '建立敬虔的家庭，',
      line3: '培養敬虔的後代。',
      verse: '我們不會向他們的子孫隱瞞這些事，而是要將主榮耀的作為、祂的大能和祂奇妙的作為傳揚給後代。',
      attribution: '— 詩篇 78:4',
    },
    anthology: {
      heading: '文集',
      clickCaption: '點擊 📖 閱讀！',
      description1: '以下文集由布魯克林社區基督教會，青少年暑期「聖經培訓營 SBI (Summa Bible Institute) 7.0」於 2023 年夏天創作。我們的目標是效法提摩太前書 4:12 的教導：',
      verse: '不可叫人小看你年輕，總要在言語、行為、愛心、信心、清潔上，都作信徒的榜樣。',
      description2: '每位 SBI 成員都寫下了自己的見證，詳細講述了他們如何經歷神，以及他們接受耶穌基督為救主的故事。除了見證之外，我們也分享各自的創作作品，以表達我們對耶穌的信心。神在我們生命中許多的作為，我們只想與您分享。盼望這些作品能激勵和感動您。',
      directors: 'SBI 7.0 負責同工',
      directorsNames: 'Simeon Leung and Cullen Ye',
    },
    services: {
      heading: '崇拜時間與地點',
      nextSunday: '下个主日崇拜',
      combinedNoteIntro: '特定節日為中英聯合崇拜，',
      combinedNoteHighlight: '一般崇拜',
      combinedNoteSuffix: '時間：',
      combinedSubtext: '中英聯合崇拜',
      chinese: { name: '中文崇拜' },
      english: { name: '英文崇拜' },
      specials: {
        easterSunday: '復活節主日崇拜',
        mothersDay:   '母親節崇拜',
        fathersDay:   '父親節崇拜',
      },
      regularNote: '中英聯合崇拜：上午 10:00–12:00，適用於特定節日（復活節、母親節、父親節、聖誕節）。',
    },
    zoom: {
      actionText: '崇拜直播中 • 立即加入',
    },
    fellowships: {
      heading: '團契一览',
      weeklyHeading: '每週聚會',
      viewAll: '查看所有團契',
      colFellowship: '團契',
      colDayTime: '日期 / 時間',
      requiresReg: '（需要報名）',
      online: '（線上）',
      entries: {
        mandarinAdultSundaySchool: { name: '普通話成人主日學',   time: '主日，中午 12:00 - 下午 1:00' },
        mensGroup:                  { name: '弟兄團契',           time: '主日，下午 12:30 - 2:30' },
        sistersTheologyClass:       { name: '姊妹神學班',         time: '主日，下午 1:30 - 2:30' },
        qaTheologyDiscussion:       { name: '神學問答討論',       time: '主日，下午 5:30 - 6:30' },
        eveningSing:                { name: '晚間敬唱',           time: '主日，晚上 8:00 - 9:00' },
        chineseEveningService:      { name: '中文晚間崇拜',       time: '主日，晚上 9:30 - 10:30' },
        englishPrayerMeeting:       { name: '英文禱告會',         time: '週二，晚上 7:30 - 9:30' },
        familyFellowship:           { name: '家庭團契',           time: '週二，晚上 8:00 - 9:30' },
        wednesdayBibleStudy:        { name: '週三上午查經禱告會', time: '週三，上午 9:00 - 11:30' },
        chinesePrayerMeeting:       { name: '中文禱告會',         time: '週三，晚上 8:00 - 9:30' },
        elderlyFellowship:          { name: '長者團契',           time: '週四，上午 10:00 - 中午 12:00' },
        godkeyFellowship:           { name: '歌基團契',        time: '週五，晚上 7:45 - 10:00' },
        fridayNightFellowship:      { name: '週五晚間團契',       time: '週五，晚上 7:30 - 9:30' },
        mandarinFellowship:         { name: '普通話團契',         time: '週五，晚上 7:30 - 9:30' },
        cantoneseFellowship:        { name: '粵語團契',           time: '第一、二、三週五，晚上 7:00 - 8:30' },
        practicalTheologyClass:     { name: '實踐神學班',         time: '週六，上午 9:00 - 10:30' },
      },
    },
    sof: {
      heading: '信仰聲明',
      item1: '我們相信，所有聖經，包括舊約和新約的 66 本書，都是惟一從神而來無誤的上帝之道。在信仰和行為的所有事上，聖經都是至高的權威。',
      item2: '我們相信，有一個永活而真實的上帝，永恆地存在三位，即父，子和聖靈，在力量和榮耀上是平等的；這個三位一體的上帝創造了一切，擁有一切並統治一切。',
      item3: '我們相信，我們的主耶穌基督是上帝的兒子-既是上帝又是世人的救世主，並且通過他的生命，死亡和復活為人類贖罪祭。',
      item4: '我們相信，認罪，悔改和接受耶穌基督作為個人救主是罪人可以繼承永生的唯一途徑。',
      item5: '我們相信聖靈，這是三位一體的第三位，使人們與上帝建立了拯救的關係，並且他是所有接受耶穌基督作為個人救主的安慰者和辅導。',
      item6: '我們相信，人類是按照上帝的形像被創造出來的，目的是榮耀上帝。我們認為，墮落的結果是，罪惡成為人類的普遍條件，而罪惡將整個人類定罪至死。',
      item7: '我們相信，到了末日，主耶穌基督將從天上降下來，使祂的子民重新獲得永生，並審判惡人。',
      item8: '我們相信，教會是信徒的身體，在基督裡團結，以基督為首。無形和普遍的教會是由各個年齡段的人組成的。當地教堂是無形教會的有形实體。',
      item9: '我們相信，水的洗禮是基督作為生命中救主和主的公開認罪。它像徵著在死亡，埋葬和復活中與基督 結合的信仰。',
      item10: '我們相信，所有信徒都應遵守主餐。它包括領餅和杯紀念基督為救贖我們的罪而死，也像徵著我們對基督持續倚靠。',
      item11: {
        pre: '布魯克林社區基督教會自願與',
        sbc: '南方浸信會聯合會',
        mid: '合作。我們的信仰與',
        bfm: '浸信會信仰與信息',
        post: '中的核心教義一致。',
      },
    },
    team: {
      heading: '認識同工',
      subtitle: '以信心、智慧與憐憫牧養我們的群體',
      members: {
        andyTso: {
          role: '主任牧師',
          bio: `左永昌牧師是在紐約長大的第一代移民的餐廳小孩。讀紐約市公立小學、天主教高中，畢業於紐約大學（學士）、歌登康威爾神學院（道學碩士），以紐約州律師身份退休。他出名的是：父親是「橙皮牛」的始祖。他能講流利的布魯克林英語、普通話、粵語和閩南語。

左牧師參與教牧事工超過 30 年。左牧師及師母在家教育四個孩子，現皆已成年並已婚，有四個孫子。最大的喜樂就是看見兒孫們都「行在真理中」。`,
        },
        simeonLeung: {
          role: '助理牧師',
          bio: `梁存謙助理牧師主要服事高中生，同時支持教會的各項事工。他於 2021 年開始全職服事，渴望忠心教導神的話語，並帶領下一代以喜樂和熱心跟隨基督。他目前正在接受美南浸信會神學院的課程，以進一步裝備自己，勝任事工。除了牧養職責外，他熱愛音樂，經常透過彈奏吉他和鋼琴來帶領敬拜。閒暇時，也喜歡戶外探險、打排球，以及有關神學探討的對話，尋求聖經真理。`,
        },
        cullenYe: {
          role: '實習傳道',
          bio: `葉健樂是教會的實習傳道，負責督導大學事工、帶領暑期高中事工，並定期講道和教導。他畢業於密西根大學（Go Blue!），獲得計算機工程學士學位，但很快地便感受到上帝的呼召，參與全職事奉。他目前在美南浸信會神學院攻讀道學碩士學位，主修護教學和哲學。他熱衷於幫助他人深入思考信仰，並希望在哲學和神學領域繼續深造。事工之餘，他喜歡舉重、打乒乓球、彈吉他、閱讀和看大學橄欖球比賽。`,
        },
      },
    },
    footer: {
      tagline: '布魯克林的信仰社區',
      contactHeading: '聯絡我們',
      followHeading: '關注我們',
      address1: '2287 East 15th St.',
      address2: 'Brooklyn, NY 11229',
      copyright: '布魯克林社區基督教會。版權所有。',
    },
  },
};
